import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { HandleApiError } from '../../components/Notifications/APIErrorHandler';
import { Success } from '../../components/Notifications/Notifications';
import { MedicalCenterForm } from '../../components/MedicalCenters/MedicalCenter';
import { useMedicalCenters } from './Hooks';
import { Spinner } from '../../components/Utils/Loaders';
import { useAuthorization } from '../../components/Authorization/useAuthorization';

export const EditMedicalCenterContainer = (props) => {
    const { match: { params: { medicalCenterId } } } = props;
    const history = useHistory();
    const [, , isAuthorized] = useAuthorization();
    const tenantId = new URLSearchParams(props.location?.search).get('tenantId');
    const isSuperAdmin = isAuthorized(['Tenant.View']);
    const backPath = tenantId
        ? `/admin/settings/medicalcenters?tenantId=${encodeURIComponent(tenantId)}`
        : '/admin/settings/medicalcenters';
    const [data, setData] = useState(null);
    const [, isLoading, , get, , update] = useMedicalCenters(tenantId);

    useEffect(() => {
        let isSubscribed = true;
        const fetchData = async () => {
            const resp = await get(medicalCenterId, isSubscribed);
            if (isSubscribed) setData(resp);
        };
        fetchData();
        return () => { isSubscribed = false; };
    }, [medicalCenterId]);

    if (isLoading || !data) return <Spinner />;

    const handleEdit = async (values) => {
        try {
            await update(medicalCenterId, {
                name: values.name,
                userIds: values.userIds ?? [],
            });
            Success('medicalCenterNotifications.updated');
            history.push(backPath);
        } catch (error) {
            HandleApiError(error);
        }
    };

    return (
        <MedicalCenterForm
            initialValues={{
                name: data.name ?? '',
                userIds: (data.users ?? []).map(u => u.userId),
                users: data.users ?? [],
            }}
            onSubmit={handleEdit}
            onCancel={() => history.push(backPath)}
            tenantId={tenantId}
            isSuperAdmin={isSuperAdmin}
        />
    );
};
